module.exports = __webpack_public_path__ + "fonts/Graphik-ThinItalic-Web.05b4e44.woff";